// BF library of actions
import { socket, connectivity } from "Js/feathers"; //app, scriptService
// import { actions } from "Js/actionsProcessor";
// import { EventBus } from "Js/eventBus";
// import router from "Js/routes.js";
// import runHook from "Js/hookHandler";
import { Uuid } from 'Js/bfUtilities';
import store from "Js/store";
import { errorHandler } from "Js/errorHandler";
import { getPaths } from "Js/bfUtilities.js";
import { loadLibraryOnce, isLibraryLoaded, getLoadedLibraries } from 'Js/libraryLoader';
import wsDebug from "Js/wsDebug";
import { convertSiteToGlobalSchema } from './convertSiteToGlobalSchema.js';
import { readPendingTicket, clearPendingTicket, approvePendingTicket, rememberTicketFromUrl, callbackHostForTicket } from './mcpConsent.js';
import {
  buildGlobalSchemaToggleUrl,
  writePreviewSchemaToSession,
  clearPreviewSchemaFromSession,
  getGlobalSchemaTestStatus,
  prepareGlobalSchemaForRuntime
} from './globalSchemaLayout.js';
import {
  resolveCssPacks,
  readCssPacksFromSite,
  readCssPacksFromSession,
  writeCssPacksToSession,
  clearCssPacksFromSession,
  applyResolvedCssPacks,
  bootCssPacks
} from './cssPacks.js';

const BF = {};

// Always-on WebSocket / offline-gate telemetry. See
// Internal Docs/websocket-stability-feature/ for design and usage.
// Exposed here so it is reachable as BF.wsDebug / window.BF.wsDebug.
BF.wsDebug = wsDebug;
BF.connectivity = {
  getState: () => connectivity.getState(),
  isConnected: () => connectivity.isConnected()
};

//Uuid
BF.getUUID = Uuid

BF.errorThrow = function() {
    errorHandler(arguments);
};

BF.errorClearAll = function() { store.dispatch('ERROR_CLEAR'); };

BF.errorGetAll = function() { return store.state.site.errors; };

BF.authGetLastFeedback = function() {
    return store.state.auth.lastFeedback;
};

// Conenction
BF.socketDisconnect = function() { socket.disconnect() }
BF.socketConnect = function() { socket.connect() }

// Query
BF.getQueryParam = function(key) {
    var vars = [],
        hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars[key];
}

// MCP sign-in, for the app's own /auth/mcp page and its login/signup pages
function rememberMcpTicketFromUrl() {
    const ticket = BF.getQueryParam("ticket");
    rememberTicketFromUrl(window.localStorage, ticket ? decodeURIComponent(ticket) : "", Date.now());
}
BF.mcpOauthTicket = function() {
    rememberMcpTicketFromUrl();
    return readPendingTicket(window.localStorage, Date.now());
}
BF.mcpOauthCallbackHost = function() {
    return callbackHostForTicket({
        fetchFn: window.fetch.bind(window),
        ticket: BF.mcpOauthTicket()
    });
}
BF.mcpOauthApprove = function() {
    rememberMcpTicketFromUrl();
    return approvePendingTicket({
        storage: window.localStorage,
        fetchFn: window.fetch.bind(window),
        navigate: function(url) { window.location = url; },
        token: window.localStorage.getItem("feathers-jwt"),
        now: Date.now()
    });
}
BF.mcpOauthDeny = function() {
    clearPendingTicket(window.localStorage);
}

// ACTIONS
BF.actionsClear = function(action) {
    store.dispatch('ACTIONS_CLEAR', action)
}

BF.namedAction = function(name, options) {
    try {
        typeof options !== "object" && typeof options !== "undefined" ? options = JSON.parse(options) : null
        store.dispatch('ACTIONS_QUEUE', [{ action: "namedAction", name, options }])
    }
    catch (e) {
        BF.errorThrow(10159, 'String passed to BF.namedAction is not a valid JSON', 'BF.namedAction invalid parameter')
    }
}

// Misc
BF.i18n = function(key) {
    var _app = vueapp.$store.state.site.content.app
    var langSelected = _app.i18n.langSelected
    var langDefault = _app.i18n.langDefault
    if (typeof key == "undefined" || _.isEmpty(key)) { return '' }
    return _.get(_app.i18n.dict, [key, langSelected]) ||
        _.get(_app.i18n.dict, [key, langDefault]) ||
        'No default lang value or invalid key'
}

BF.rebuildReactivity = function(m) {
    for (const [key, value] of Object.entries(m)) {
        const item = m[key]
        if (item && typeof item === 'object') {
            BF.rebuildReactivity(item)
        }
        if (!Object.getOwnPropertyDescriptor(m, key).get) {
            delete m[key]
            Vue.set(m, key, value)
        }
    }
    return m
};

BF.pwaSetManifest = async function(manifest) {
    //Add Manifest
    let content = encodeURIComponent(JSON.stringify(manifest));
    let url = "data:application/manifest+json," + content;
    let element = document.createElement('link');
    element.setAttribute('rel', 'manifest');
    element.setAttribute('href', url);
    document.querySelector('head').appendChild(element);
};

// Library Loading (v3.2.31+)
BF.libraryLoadOnce = loadLibraryOnce;
BF.libraryIsLoaded = isLibraryLoaded;
BF.libraryGetLoaded = getLoadedLibraries;

// Version object: basecode from build-time constant, app from site
/** JSONPath → lodash-style paths (same as bfUtilities.getPaths); exposed for editor / named actions. */
BF.getPaths = getPaths;

BF.convertSiteToGlobalSchema = convertSiteToGlobalSchema;

// GLOBAL_SCHEMA_DEV_PREVIEW — temporary dial-in helpers; remove when beta testing is complete.
// See Internal Docs/global-schema-feature/GLOBAL_SCHEMA_DEV_PREVIEW_REMOVAL.md
BF.applyGlobalSchemaPreview = function(globalSchema) {
  if (!globalSchema) {
    const site = vueapp && vueapp.$store && vueapp.$store.state.site;
    globalSchema = convertSiteToGlobalSchema(site).globalSchema;
  }

  globalSchema = prepareGlobalSchemaForRuntime(globalSchema);

  Vue.set(vueapp.$store.state.site.content, 'globalSchema', globalSchema);
  writePreviewSchemaToSession(globalSchema);
  vueapp.$store.commit('SET_GLOBAL_SCHEMA_TEST_MODE', 'global');

  console.log('[globalSchema] Preview applied. Use dev panel Legacy/Global buttons or BF.setGlobalSchemaTestMode().');
  console.log('[globalSchema] Status:', BF.getGlobalSchemaTestStatus());

  return globalSchema;
};

BF.clearGlobalSchemaPreview = function() {
  if (vueapp && vueapp.$store && vueapp.$store.state.site && vueapp.$store.state.site.content) {
    Vue.delete(vueapp.$store.state.site.content, 'globalSchema');
  }
  clearPreviewSchemaFromSession();
  vueapp.$store.commit('SET_GLOBAL_SCHEMA_TEST_MODE', 'legacy');
  console.log('[globalSchema] Preview cleared.');
};

BF.setGlobalSchemaTestMode = function(mode) {
  if (!vueapp || !vueapp.$store) return null;

  if (mode === 'global') {
    BF.reconvertGlobalSchemaPreview();
    return BF.getGlobalSchemaTestStatus();
  }

  vueapp.$store.commit('SET_GLOBAL_SCHEMA_TEST_MODE', mode);
  console.log('[globalSchema] Test mode:', BF.getGlobalSchemaTestStatus());
  return BF.getGlobalSchemaTestStatus();
};

BF.getGlobalSchemaTestStatus = function() {
  if (!vueapp || !vueapp.$store) {
    return {
      testMode: null,
      queryOverride: null,
      hasPreviewSchema: false,
      activeLayout: 'legacy'
    };
  }

  return getGlobalSchemaTestStatus(
    vueapp.$store.state.site.content,
    BF.getQueryParam('_forceGlobalSchema'),
    vueapp.$store.state.site.globalSchemaTestMode
  );
};

BF.reconvertGlobalSchemaPreview = function() {
  const result = convertSiteToGlobalSchema(vueapp.$store.state.site);
  BF.applyGlobalSchemaPreview(result.globalSchema);
  console.log('[globalSchema] Re-converted preview.', result.report);
  return result;
};

BF.getGlobalSchemaToggleUrl = buildGlobalSchemaToggleUrl;

BF.setCssPack = function(patch) {
  const content = vueapp && vueapp.$store && vueapp.$store.state.site
    ? vueapp.$store.state.site.content
    : null;
  const packs = resolveCssPacks({
    sitePacks: readCssPacksFromSite(content),
    sessionPacks: readCssPacksFromSession() || {},
    patch: patch || {}
  });
  writeCssPacksToSession(packs);
  applyResolvedCssPacks(packs);
  console.log('[cssPacks]', packs);
  return packs;
};

BF.getCssPack = function() {
  const content = vueapp && vueapp.$store && vueapp.$store.state.site
    ? vueapp.$store.state.site.content
    : null;
  return resolveCssPacks({
    sitePacks: readCssPacksFromSite(content),
    sessionPacks: readCssPacksFromSession() || {}
  });
};

BF.clearCssPack = function() {
  clearCssPacksFromSession();
  const content = vueapp && vueapp.$store && vueapp.$store.state.site
    ? vueapp.$store.state.site.content
    : null;
  const packs = bootCssPacks(content);
  console.log('[cssPacks] session cleared', packs);
  return packs;
};

BF.getVersion = function() {
    const basecode = (typeof __APP_VERSION__ !== 'undefined' && __APP_VERSION__) ||
      (vueapp?.$store?.state?.version) ||
      (vueapp?.$store?.state?.site?.version) ||
      (vueapp?.$store?.state?.site?.content?.app?.version);
    const app = (vueapp?.$store?.state?.site?.content?.app?.version) || (vueapp?.$store?.state?.site?.hash);
    return { basecode, app };
}

// Convert data to be compatible with VFG3
BF.convertToVFG3 = function(data) {
    var schema = data
    // *****
    // 1: convert to groups (pages..groups, schema..groups)
    let paths = getPaths(schema, `$..groups`).sort((a, b) => b.length - a.length); //deeper paths first and roll upward
    paths.forEach(path => {
        let group = _.get(schema, path.substr(5));
        let fieldsPath = path.substr(5).slice(0, -6) + 'fields' // remove group and add fields
        
        if (Array.isArray(group) && group.length > 0) {
            group.forEach(item => {
                if (!item || typeof item !== 'object' || Array.isArray(item)) {
                    return;
                }
                item.type = 'group';
                item.tag = 'div';
                let fields = _.get(schema, fieldsPath);
                fields ? fields.push(item) : _.set(schema, fieldsPath + '[0]', item);
    
            });
            schema = _.omit(schema, path.substr(5))
        }
    });

    // Infer missing `type` from shape (LLM/import sometimes omits it).
    // Tree labels use BFName || type — typeless group/html nodes render blank.
    function typeMissing(item) {
        return item.type === undefined || item.type === null || item.type === '';
    }
    function inferMissingFieldTypes(fields) {
        if (!Array.isArray(fields)) {
            return;
        }
        fields.forEach(item => {
            if (!item || typeof item !== 'object' || Array.isArray(item)) {
                return;
            }
            if (typeMissing(item)) {
                if (Array.isArray(item.fields)) {
                    item.type = 'group';
                    if (!item.tag) {
                        item.tag = 'div';
                    }
                } else if (typeof item.html === 'string') {
                    item.type = 'html';
                }
            }
            if (Array.isArray(item.fields)) {
                inferMissingFieldTypes(item.fields);
            }
        });
    }
    (schema.pages || []).forEach(page => {
        const pageFields = _.get(page, 'schema.fields');
        inferMissingFieldTypes(pageFields);
    });

    // ********
    // 2: convert  {selectOptions, ...} to fieldOptions
    paths = getPaths(schema, `$.pages..selectOptions`) // data.pages[0].schema.fields[0].fields[2].selectOptions
    paths.forEach(path => {
        //TODO theKey for last chunk
        let thePath = path.slice(5)
        let theValue = _.get(schema, path.slice(5))
        let theElement = thePath.slice(0, -13) + "fieldOptions"
        let existingOptions = _.get(schema, theElement) || {}
        let mergedOptions = Object.assign({}, theValue, existingOptions)
        _.set(schema, theElement, mergedOptions)
        schema = _.omit(schema, thePath)
    })
    // ********
    // 2: convert element options to fieldOptions
    const elementTypeMapping = {
        cleave: {
            targetType: "fieldOptions",
            oldPaths: ["cleaveOptions", "autocomplete"],
            mergePaths: ["cleaveOptions"],
            defaultOptions: {}
        },
        input: {
            targetType: "fieldOptions",
            oldPaths: ["inputType", "autocomplete"],
            defaultOptions: {
                inputType: "text"
            }
        },
        dateTimePicker: {
            targetType: "fieldOptions",
            oldPaths: ["format", "dateTimePickerOptions"],
            mergePaths: ["dateTimePickerOptions"],
            defaultOptions: {}
        },
        pikaday: {
            targetType: "fieldOptions",
            oldPaths: ["pikadayOptions"],
            mergePaths: ["pikadayOptions"],
            defaultOptions: {}
        },
        masked: {
            targetType: "fieldOptions",
            oldPaths: ["mask", "maskOptions"],
            defaultOptions: {}
        },
        noUiSlider: {
            targetType: "fieldOptions",
            oldPaths: ["min", "max", "noUiSliderOptions"],
            mergePaths: ["noUiSliderOptions"],
            defaultOptions: {}
        },
        rangeSlider: {
            targetType: "fieldOptions",
            oldPaths: ["min", "max", "step", "rangeSliderOptions"],
            mergePaths: ["rangeSliderOptions"],
            defaultOptions: {}
        },
        selectEx: {
            targetType: "fieldOptions",
            oldPaths: ["multiSelect"],
            defaultOptions: {}
        },
        vueMultiSelect: {
            targetType: "fieldOptions",
            oldPaths: [],
            defaultOptions: {}
        },
        spectrum: {
            targetType: "fieldOptions",
            oldPaths: ["colorOptions"],
            mergePaths: ["colorOptions"],
            defaultOptions: {}
        },
        staticMap: {
            targetType: "fieldOptions",
            oldPaths: ["staticMapOptions"],
            mergePaths: ["staticMapOptions"],
            defaultOptions: {}
        },
        switch: {
            targetType: "fieldOptions",
            oldPaths: ["textOn", "textOff", "valueOn", "valueOff"],
            defaultOptions: {}
        },
        googleAddress: {
            targetType: "fieldOptions",
            oldPaths: ["onPlaceChanged", "autocomplete"],
            defaultOptions: {}
        },
        image: {
            targetType: "fieldOptions",
            oldPaths: ["preview", "hideInput", "browse", "autocomplete"],
            defaultOptions: {}
        },
        textArea: {
            targetType: "fieldOptions",
            oldPaths: ["min", "max", "rows"],
            defaultOptions: {
                rows: 6
            }
        }
    };

    Object.keys(elementTypeMapping).forEach(elementType => {
        const paths = getPaths(schema, `$.pages..[?(@.type == '${elementType}')]`);
        paths.forEach(schemaPath => {
            updateFieldOptions(schema, elementType, schemaPath);
        });
        
    });

    getPaths(schema, `$.pages..[?(@.type == 'input')]`).forEach(schemaPath => {
        normalizeInputAttributes(schema, schemaPath.slice(5));
    });

    function updateFieldOptions(schema, elementType, schemaPath) {
        schemaPath = schemaPath.slice(5);
        const mapping = elementTypeMapping[elementType];
        const defaultOptions = { ...mapping.defaultOptions };
        const fieldOptionsPath = schemaPath + "." + mapping.targetType;
        let fieldOptionsValue = _.get(schema, fieldOptionsPath);
        const hasExistingOptions = fieldOptionsValue !== undefined;
        const mergePaths = new Set(mapping.mergePaths || []);

        mapping.oldPaths.forEach(path => {
            let userSetValue = _.get(schema, schemaPath + `.${path}`);

            // if there is no fieldOptions key default
            if (fieldOptionsValue == undefined) fieldOptionsValue = defaultOptions;
            // set fieldOptions with new options
            if (userSetValue !== undefined) {
                if (mergePaths.has(path) && userSetValue && typeof userSetValue === 'object' && !Array.isArray(userSetValue)) {
                    const merged = { ...fieldOptionsValue };
                    Object.keys(userSetValue).forEach(key => {
                        if (merged[key] === undefined) merged[key] = userSetValue[key];
                    });
                    fieldOptionsValue = merged;
                    _.set(schema, fieldOptionsPath, merged);
                } else {
                    const nextOptions = { ...fieldOptionsValue };
                    const shouldSet = !hasExistingOptions || nextOptions[path] === undefined;
                    if (shouldSet) nextOptions[path] = userSetValue;
                    fieldOptionsValue = nextOptions;
                    _.set(schema, schemaPath + "." + mapping.targetType, nextOptions);
                }
                // omit old paths
                schema = _.omit(schema, schemaPath + `.${path}`);
            }
        })
    }

    function normalizeInputAttributes(schema, schemaPath) {
        const legacyAttrPaths = [
            { attrPath: "attributes.input.id", targetKey: "id" },
            { attrPath: "attributes.input.name", targetKey: "inputName" },
            { attrPath: "attributes.formElement.id", targetKey: "id" },
            { attrPath: "attributes.formElement.name", targetKey: "inputName" }
        ];
        const legacyAutocompletePaths = [
            "attributes.input.autocomplete",
            "attributes.formElement.autocomplete"
        ];

        legacyAttrPaths.forEach(({ attrPath, targetKey }) => {
            const targetPath = `${schemaPath}.${targetKey}`;
            const legacyPath = `${schemaPath}.${attrPath}`;
            const canonicalValue = _.get(schema, targetPath);
            const legacyValue = _.get(schema, legacyPath);

            if (canonicalValue === undefined && legacyValue !== undefined) {
                _.set(schema, targetPath, legacyValue);
            }

            if (legacyValue !== undefined) {
                schema = _.omit(schema, legacyPath);
            }
        });

        const topLevelNamePath = `${schemaPath}.name`;
        const canonicalInputNamePath = `${schemaPath}.inputName`;
        const canonicalInputName = _.get(schema, canonicalInputNamePath);
        const topLevelName = _.get(schema, topLevelNamePath);

        if (canonicalInputName === undefined && topLevelName !== undefined) {
            _.set(schema, canonicalInputNamePath, topLevelName);
        }

        if (topLevelName !== undefined) {
            schema = _.omit(schema, topLevelNamePath);
        }

        legacyAutocompletePaths.forEach(attrPath => {
            const targetPath = `${schemaPath}.fieldOptions.autocomplete`;
            const legacyPath = `${schemaPath}.${attrPath}`;
            const canonicalValue = _.get(schema, targetPath);
            const legacyValue = _.get(schema, legacyPath);

            if (canonicalValue === undefined && legacyValue !== undefined) {
                _.set(schema, targetPath, legacyValue);
            }

            if (legacyValue !== undefined) {
                schema = _.omit(schema, legacyPath);
            }
        });

        ["attributes.formElement", "attributes.input"].forEach(containerPath => {
            const fullPath = `${schemaPath}.${containerPath}`;
            const container = _.get(schema, fullPath);
            if (container && typeof container === "object" && !Array.isArray(container) && Object.keys(container).length === 0) {
                schema = _.omit(schema, fullPath);
            }
        });
    }
    return schema

}

/*===============================*/
window.bf = window.BF = BF
export default BF;
